import { Navigate, useParams } from 'react-router-dom';
import { PATH_CONSTANT } from 'constant/PathConstant';
import { TableDefinitionEditorForm } from './components/TableDefinitionEditorForm';
import { isTableDefinitionKind } from './utils/tableDefinitionRoutes';

export default function EditTableDefinitionPage() {
  const { subjectId, definitionKind, tableDefinitionId } = useParams<{
    subjectId: string;
    definitionKind: string;
    tableDefinitionId: string;
  }>();
  if (!subjectId || !tableDefinitionId || !isTableDefinitionKind(definitionKind)) {
    return <Navigate to={PATH_CONSTANT.SYSTEM.KMS.DATA_BUILDER.TABLE_DEFINITION_V2.LIST} replace />;
  }
  return (
    <TableDefinitionEditorForm
      mode='edit'
      subjectId={subjectId}
      definitionKind={definitionKind}
      tableDefinitionId={tableDefinitionId}
    />
  );
}

